<template>
  <b-modal
    :id="id"
    size="sm"
    :title="trans('modify')"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <b-form-group :label="trans('name')">
      <b-form-input ref="input" v-model="name" autocomplete="0" :disabled="busy" />
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'modify-tag-modal',
      },
      organization: Object,
      tag: Object,
      label: {
        type: String,
        default: 'tag',
      },
      type: String,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        name: this.tag ? this.tag.name : null,
      }
    },
    computed: {
      serialized() {
        return {
          name: this.name,
          type: this.type == 'student' ? this.type : null,
        }
      }
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
        this.name = this.tag ? this.tag.name : null
        this.$refs.input.focus()
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/tags/${this.tag.id}`
        axios.patch(url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onKeydown(e) {
        if (e.keyCode == 13) this.onSave(e)
      },
    },
    mounted() {
      window.modifyTagModal = this
    },
  }
</script>